import script from "./EventRoute.vue?vue&type=script&setup=true&lang=js"
export * from "./EventRoute.vue?vue&type=script&setup=true&lang=js"

import "./EventRoute.vue?vue&type=style&index=0&id=cb73e8a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cb73e8a4"]])

export default __exports__